<template>
  <div>
  <div class="spe-coupons" v-if="!json.init" :style="commonStyle" :ddt-area="`component_${json.floorId}_礼券组件`" ddt-expose="on">
    <div v-for="(v,k) in discountCodes" :key="k" class="coupon-mr" :class="{'no-left-right-padding': jdata.commonStyle.margin}">
      <!-- 一行一张 -->
      <div :class="{'one':v.length == 1,'two':v.length == 2,'more':v.length > 2, 'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}"  :style="fontStyle">
        <div class="coupons top" :class="{'bg1': jdata.columnsType == 2, 'bg2': jdata.columnsType == 3, 'bg3': jdata.columnsType == 4}"  data-sourceid="5"  v-for="(item, index) in v" v-if="item"  :key="`${item.actNum}one`" :style="cartStyle" :data-actid="item.actNum" >
          <div class="l" :class="(item.activityStatus == 1 || (item.activityStatus == 5 && item.coupons[0].btnLinkUrl)) ? '': 'opacity-half'">
            <div class="price" v-if="item.coupons[0].couponApplyMoneyType== 2 || item.coupons[0].couponApplyMoneyType== 3">{{item.coupons[0].couponValue}}<span >折</span></div>
            <div class="price" v-else><span class="yuan">¥</span>{{item.coupons[0].couponValue}}</div>
            <div class="use" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}">{{item.coupons[0].couponMinDiscountDescription}}</div>
          </div>
          <div class="c" :style="dashStyle"></div>
          <div class="r" :class="(item.activityStatus == 1 || (item.activityStatus == 5 && item.coupons[0].btnLinkUrl)) ? '': 'opacity-half'">
            <div class="title" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}">{{item.coupons[0].couponDescription}}</div>
            <div class="time2" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}" v-if="item.timeSharingDescription">抢券时间:{{item.timeSharingDescription}}</div>
            <div class="time2" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}" v-else>有效期:{{item.coupons[0].validity}}</div>
            <div
              class="btn top"
              v-if="item.activityStatus == 1"
              @click="goto($event,item)"
              :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}" 
              :style="btnStyle"
              :data-area="pt()"
              :data-pos="`component_${json.floorId}_礼券组件.坑位{index + 1}_点击立即领取按钮`"
              :data-desc="item.actNum"
              :dd_name="`${pt()}.component_${json.floorId}_礼券组件.坑位${index + 1}_点击立即领取按钮.${item.actNum}`"
              :ddt-click="`${pt()}.component_${json.floorId}_礼券组件.坑位${index + 1}_点击立即领取按钮.${item.actNum}`"
              :ddt-pit="`坑位${index + 1}_点击立即领取按钮`"
              :ddt-src="item.actNum"
              ddt-expose="on"
            >立即领取</div>
            <div class="btn" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}"  v-else-if="item.activityStatus == 0" :style="btnStyle">未开始</div>
            <div class="btn" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}"  v-else-if="item.activityStatus == 2" :style="btnStyle">已抢光</div>
            <div class="btn" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}"  v-else-if="item.activityStatus == 3" :style="btnStyle">已结束</div>
            <div class="btn top" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}"  v-else-if="item.activityStatus == 5 && item.coupons[0].btnLinkUrl" @click="toLink(item)" :style="btnStyle">去使用</div>
            <div class="btn opacity-half" :class="{'type1': jdata.columnsType == 2, 'type2': jdata.columnsType == 3, 'type3': jdata.columnsType == 4}"  v-else-if="item.activityStatus == 4 || item.activityStatus == 5" :style="btnStyle">已领取</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import '../assets/js/getcoupon'
import { formatDate } from  '../assets/js/format'

export default {
  name: "spe-coupons",
  props: {
    json: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      discountCodes:[],
      cid: '-1',
      userClient:'',
    }
  },
  inject: ['pt'],
  filters: {
    format_filter(v) {
      return formatDate(v)
    }
  },
  computed: {
    jdata() {
      return this.json.data || { commonStyle: {}, headerStyle: {} ,header:{}, explainStyle:[],fontStyle:{},btnStyle:{},dashStyle:{}};
    },
    commonStyle() {
      let sty = {};
      if (this.jdata.commonStyle.backgroundType == 1) {
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      } else if(this.jdata.commonStyle.backgroundType == 2){
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
      }
      sty.padding = `0 ${this.jdata.commonStyle.margin || 0}px`
      return sty;
    },
    cartStyle() {
      const columnsType = this.jdata.columnsType
      if (columnsType == 1) {
        return {
          backgroundColor:  this.jdata.pitBgColor,
          color : this.jdata.fontColor,
          '--beforBorderColor':this.jdata.fontColor
        }
      }
    },
    fontStyle(){
      const columnsType = this.jdata.columnsType
      if (columnsType == 1) {
        return {
          color:this.jdata.fontColor || this.jdata.fontDefaultColor
        }
      }
    },
    btnStyle(){
      const columnsType = this.jdata.columnsType
      if (columnsType == 1) {
        return {
          backgroundColor:this.jdata.fontColor || this.jdata.fontDefaultColor,
          color:this.jdata.pitBgColor
        }
      }
    },
    dashStyle(){
      const columnsType = this.jdata.columnsType
      if (columnsType > 1) {
        return {
          display: 'none',
        }
      } else {
        return{
          borderRightColor: this.jdata.fontColor || this.jdata.fontDefaultColor
        }
      }
    }
  },
  watch: {
    json: {
      handler(newVal, oldVal) {
        newVal ? this.getPromotionCodesInfo(JSON.parse(JSON.stringify(newVal))) : ''
      },
      deep: true,
      immediate: false
    },
    discountCodes: {
      handler(newVal, oldVal) {
        this.discountCodes = newVal
      },
      deep: true,
      immediate: true
    },
  },
  created() {
  },
  mounted() {
     this.userClient = this.$route.query.user_client || ''
  },
  methods:{
    /**
     * 获取优惠码
     */
    async getPromotionCodesInfo(newVal) {
      let { errorCode, data } =  await this.$axios.get("/jmapi/cms/promotion/couponInfo", { params:{floorId:newVal.floorId, pt: this.$route.query.pt} })
      if(!data) return;
      let { ids = [], list = [] } = data, arr = [];
      if(list.length <= 0) return ;
      ids.forEach((v,k)=>{
        let line = v.split(','),sortArr = []
        line.forEach(id=>{
          let findItem = list.filter(item => {return item.actNum == id})[0]
          findItem ? sortArr.push(findItem) : ''
        })
        arr[k] = sortArr.length > 0 ? sortArr : ''
      })
      this.$set(this,'discountCodes',arr)
    },
    toLink(item) {
      if (item.coupons[0].btnLinkUrl) {
        this.$sys.dict.href(item.coupons[0].btnLinkUrl)
      }
    },
    goto(e,item){
      // process.env.VUE_APP_domain_shop
      let that = this
      let $obj = $(event.target).parents('.top');
      // getCoupon.env = 1; //TODO
      getCoupon.env = +process.env.VUE_APP_COUPON_ENV;//TODO
      let login_url = getCoupon.login_url = process.env.VUE_APP_MDD_LOGIN_URL + window.location.href;
      let url_ = window.location.href
      getCoupon.yzm({
        target: $obj ,
        type: 'xz',
        noBindMobile: function(){
          //信息
          // layer.open({
          //   content: '请到当当客户端绑定手机号'
          //   ,btn: '知道了'
          // });
          that.$toast( '请到当当客户端绑定手机号')
          // pop.popup({type:'alert', text:'请到当当客户端绑定手机号', determine_name:'知道了', isInitMask:true});
        },
        noLogin: function(){
          const userClient = that.userClient
          if(userClient == 'iphone' || userClient == 'android'){
            appBridge.callLogin({
              response: "after_login",
            })
            window.after_login = res => {
              window.location.href = url_
            }
          }else if(userClient == 'mina'){
            let toUrl = url_ ? url_ : ''
            // let loginUrl = '/pages/login/login?url=/pages/cms/webview?url=' + encodeURIComponent(toUrl)
            let loginUrl = '/pages/login/login'
            wx.miniProgram.navigateTo({url: loginUrl})
          }else if (userClient == "huawei") {
            system.go("/login");
          }else{//触屏
            window.location.href= login_url;
            // window.location.href= 'https://mpassport.dangdang.com/login.php?burl=' + window.location.href;
          }
        },
        getCouponSuccess: function(data){
          that.$toast(data ? data.errorMsg : '领券成功')
          console.info('data-----------',  data, data.errorCode === 0 , data.errorCode ===500)
          if( data && (data.errorCode === 0 || data.errorCode ===500) ) {
            that.$set(item,'activityStatus', 5)
          } else {
            that.$set(item,'activityStatus', 4)
          }
          // e.target.innerHTML = "已领取"
          // e.target.offsetParent.className = "coupons top opacity-half"
        },
        xzSuccess: function(data, status){
          //console.log(data);
        },
        xzError: function(){
          that.$toast( '出错啦~请重试')
        },
        identifyingCodeError: function(data){
          that.$toast(data ? data.errorMsg : '出错啦~请重试')
        },
        pickCouponError: function(data){
          setTimeout(function() {
            that.$toast(data ? data.errorMsg : '出错啦~请重试')
          }, 300);
        },
        dxError: function(data){
          that.$toast(data ? data.errorMsg : '出错啦~请重试')
        },
        dxTips: function(data){
          that.$toast(data ? data.errorMsg : '出错啦~请重试')
        },
        buildIdentifyingCodeError: function(text){
          //获取验证码出错
          that.$toast(text ? text : '获取验证码出错')
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
.spe-coupons{
  padding: .3rem 0rem;
  box-sizing: border-box;
  background-position: 0 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .opacity-half{
    opacity: 0.5;
  }
  .one {
    margin-bottom: .1rem;
    color: #F23440;
    padding: 0rem .2rem;
    &.type1{
      color: #FF5039;
    }
    &.type2{
      color: #141414;
    }
    &.type3{
      color: #FFFFFF;
    }
    .coupons{
      width: 100%;
      height: 1.72rem;
      background-color: #FFEBEB;
      border-radius: .08rem;
      position: relative;
      overflow: hidden;
      padding: .18rem 0rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      &.bg1 {
        background-image: url('https://img63.ddimg.cn/upload_img/00812/h5/bg_coupon1_big-1682481035.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &.bg2 {
        background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/bg_coupon2_big-1681283187.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &.bg3 {
        background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/bg_coupon3_big-1681283488.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      .l{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 1.83rem;
        flex-shrink: 0;

        .price{
          font-size: .48rem;
          letter-spacing: 0;
          text-align: justify;
          line-height: .52rem;
          font-weight: 600;
          > span{
            font-size: .24rem;
            line-height: .32rem;
          }
        }
        .use{
          opacity: 0.7;
          font-size: .24rem;
          text-align: center;
          line-height: .24rem;
          font-weight: 400;
          margin-top: .12rem;
          &.type1 {
            color: #FF5C46;
          }
          &.type2 {
            color: #444444;
          }
          &.type3 {
            color: rgba(255,255,255,0.90);
          }
        }
      }
      .c{
        height: 100%;
        opacity: 0.7;
        border-right-color: #F23440;
        border-right-style: dashed;
        border-right-width: .02rem;
      }
      .r{
        padding-left: .47rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .title{
          font-size: .32rem;
          font-weight: bold;
          &.type1 {
            color: #FFFFFF;
            font-weight: 400;
          }
          &.type2 {
            color: #141414;
            font-weight: 400;
          }
          &.type3 {
            color: #A15D19;
            font-weight: 400;
          }
        }
        .time{
          opacity: 0.7;
          font-size: .24rem;
          font-weight: 400;
        }
        .time2{
          opacity: 0.7;
          font-size: .2rem;
          font-weight: 400;
          line-height: .2rem;
          /*word-break:normal;*/
          word-break:break-all;
          /*overflow: hidden;*/
          /*text-overflow: ellipsis;*/
          /*display: -webkit-box;*/
          /*-webkit-line-clamp: 3;*/
          /*line-clamp: 3;*/
          /*-webkit-box-orient: vertical;*/
          &.type1 {
            color: rgba(255,255,255,0.90);
          }
          &.type2 {
            color: #444444;
          }
          &.type3 {
            color: #B06D28;
          }
        }
        .btn{
          width: 2.24rem;
          height: .44rem;
          background: #F23440;
          border-radius: .22rem;
          font-size: .24rem;
          /*line-height: .24rem;*/
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          &.type1{
            color: #FF5039;
            background-image: linear-gradient(180deg, #FFF9E8 0%, #FFEBBC 100%);
            background-size: 100% 100%;
          }
          &.type2{
            color: #141414;
            background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/btn_coupon2_big-1681289408.png');
            background-size: 100% 100%;
          }
          &.type3{
            color: #FFFFFF;
            background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/btn_coupon3_big-1681297341.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    .coupons::before{
      content: '券';
      width: .83rem;
      height: .83rem;
      display: block;
      opacity: 0.08;
      font-size: .64rem;
      font-weight: 600;
      border-style: solid;
      border-width: .04rem;
      border-color: var(--beforBorderColor);
      border-radius: 50%;
      text-align: center;
      line-height: .83rem;
      transform: rotate(-15deg);
      position: absolute;
      left: -.26rem;
      top: -.17rem;
    }
  }

  .two{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: .1rem;
    color: #F23440;
    padding: 0rem .2rem;
    &.type1{
      color: #FF5039;
    }
    &.type2{
      color: #141414;
    }
    &.type3{
      color: #FFFFFF;
    }
    .coupons{
      width: calc(50% - 0.05rem);
      height: 1.72rem;
      background-color: #FFEBEB;
      border-radius: .08rem;
      position: relative;
      overflow: hidden;
      padding: .18rem 0rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      &.bg1 {
        background-image: url('https://img61.ddimg.cn/upload_img/00812/h5/bg_coupon1_middle-1682481110.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &.bg2 {
        background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_coupon2_middle-1681283210.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &.bg3 {
        background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_coupon3_middle-1681283515.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &:first-child {
        margin-right: 0.05rem;
      }
      &:last-child {
        margin-left: 0.05rem;
      }
      .l{
        width: 1.43rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        flex-shrink: 0;
        .price{
          font-size: .44rem;
          letter-spacing: 0;
          text-align: justify;
          line-height: .52rem;
          font-weight: 600;
          > span{
            font-size: .24rem;
            line-height: .32rem;
          }
        }
        .use{
          opacity: 0.7;
          font-size: .22rem;
          text-align: center;
          line-height: .24rem;
          font-weight: 400;
          margin-top: .12rem;
          &.type1 {
            color: #FF5C46;
          }
          &.type2 {
            color: #444444;
          }
          &.type3 {
            color: rgba(255,255,255,0.90);
          }
        }
      }
      .c{
        height: 100%;
        border-right-color: #F23440;
        border-right-style: dashed;
        border-right-width: .02rem;
        opacity: 0.7;
      }
      .r{
        width: 2.03rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 0 0.04rem 0 0.14rem;
        box-sizing: border-box;
        .title{
          font-size: .24rem;
          /*line-height: .28rem;*/
          /*height: .28rem;*/
          margin-bottom: .04rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          font-weight: bold;
          &.type1 {
            color: #FFFFFF;
            font-weight: 400;
          }
          &.type2 {
            color: #141414;
            font-weight: 400;
          }
          &.type3 {
            color: #A15D19;
            font-weight: 400;
          }
        }
        .time{
          opacity: 0.7;
          font-size: .22rem;
          font-weight: 400;
          line-height: .26rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .time2{
          opacity: 0.7;
          font-size: .18rem;
          font-weight: 400;
          line-height: .2rem;
          /*overflow: hidden;*/
          /*word-break:normal;*/
          word-break:break-all;
          /*text-overflow: ellipsis;*/
          /*display: -webkit-box;*/
          /*-webkit-line-clamp: 3;*/
          /*line-clamp: 3;*/
          /*-webkit-box-orient: vertical;*/
          &.type1 {
            color: rgba(255,255,255,0.90);
          }
          &.type2 {
            color: #444444;
          }
          &.type3 {
            color: #B06D28;
          }
        }
        .btn{
          width: 1.7rem;
          height: .40rem;
          background: #F23440;
          border-radius: .22rem;
          font-size: .24rem;
          /*line-height: .24rem;*/
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          &.type1{
            color: #FF5039;
            background-image: linear-gradient(180deg, #FFF9E8 0%, #FFEBBC 100%);
          }
          &.type2{
            color: #141414;
            background-image: url('https://img62.ddimg.cn/upload_img/00834/h5/btn_coupon2_middle-1681297183.png');
            background-size: 100% 100%;
          }
          &.type3{
            color: #FFFFFF;
            background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/btn_coupon3_middle-1681297361.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    .coupons::before{
      content: '券';
      width: .83rem;
      height: .83rem;
      display: block;
      opacity: 0.08;
      font-size: .64rem;
      font-weight: 600;
      border-style: solid;
      border-width: .04rem;
      border-color: var(--beforBorderColor);
      border-radius: 50%;
      text-align: center;
      line-height: .83rem;
      transform: rotate(-15deg);
      position: absolute;
      left: -.26rem;
      top: -.17rem;
    }
  }


  .more{
    width: max-content;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow-x: auto;
    margin-bottom: .1rem;
    color: #F23440;
    padding: 0rem .2rem;
    flex-shrink: 0;
    &::-webkit-scrollbar{width:0px;height:0px;}
    &.type1{
      color: #FF5039;
    }
    &.type2{
      color: #141414;
    }
    &.type3{
      color: #FFFFFF;
    }
    .coupons{
      width: 3.28rem;
      height: 1.72rem;
      background-color: #FFEBEB;
      border-radius: .08rem;
      position: relative;
      overflow: hidden;
      padding: .18rem 0rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      flex-shrink: 0;
      margin-right: .1rem;
      &.bg1 {
        background-image: url('https://img61.ddimg.cn/upload_img/00812/h5/bg_coupon1_small-1682481158.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &.bg2 {
        background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/bg_coupon2_small-1681283230.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &.bg3 {
        background-image: url('https://img63.ddimg.cn/upload_img/00834/h5/bg_coupon3_small-1681283533.png');
        background-size: 100% 100%;
        &::before {
          content: initial;
        }
      }
      &:last-child{
        margin-right: 0;
      }

      &:last-child:after{
        content: "";
        width: .2rem;
        height: 100%;
        position: absolute;
        right: -.2rem;
        top: 0rem;
      }
      .l{
        width: 1.43rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        flex-shrink: 0;
        .price{
          font-size: .44rem;
          letter-spacing: 0;
          text-align: justify;
          line-height: .52rem;
          font-weight: 600;
          > span{
            font-size: .24rem;
            line-height: .32rem;
          }
        }
        .use{
          opacity: 0.7;
          font-size: .22rem;
          text-align: center;
          line-height: .24rem;
          font-weight: 400;
          margin-top: .12rem;
          &.type1 {
            color: #FF5C46;
          }
          &.type2 {
            color: #444444;
          }
          &.type3 {
            color: rgba(255,255,255,0.90);
          }
        }
      }
      .c{
        height: 100%;
        opacity: 0.7;
        border-right-color: #F23440;
        border-right-style: dashed;
        border-right-width: .02rem;
      }
      .r{
        width: 1.87rem;
        padding: 0 0.02rem 0 0.08rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        box-sizing: border-box;
        .title{
          font-size: .24rem;
          /*line-height: .28rem;*/
          /*height: .28rem;*/
          margin-bottom: .04rem;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
          &.type1 {
            color: #FFFFFF;
          }
          &.type2 {
            color: #141414;
          }
          &.type3 {
            color: #A15D19;
          }
        }
        .time{
          opacity: 0.7;
          font-size: .22rem;
          font-weight: 400;
          line-height: .26rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .time2{
          opacity: 0.7;
          font-size: .18rem;
          font-weight: 400;
          line-height: .2rem;
          word-break:break-all;
          /*overflow: hidden;*/
          /*text-overflow: ellipsis;*/
          /*display: -webkit-box;*/
          /*-webkit-line-clamp: 3;*/
          /*line-clamp: 3;*/
          /*-webkit-box-orient: vertical;*/
          /*margin-bottom: .02rem;*/
          &.type1 {
            color: rgba(255,255,255,0.90);
            font-weight: 400;
          }
          &.type2 {
            color: #444444;
            font-weight: 400;
          }
          &.type3 {
            color: #B06D28;
            font-weight: 400;
          }
        }
        .btn{
          width: 1.6rem;
          height: .40rem;
          border-radius: .22rem;
          font-size: .24rem;
          /*line-height: .24rem;*/
          color: #FFEBEB;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          &.type1{
            color: #FF5039;
            background-image: linear-gradient(180deg, #FFF9E8 0%, #FFEBBC 100%);
          }
          &.type2{
            color: #141414;
            background-image: url('https://img61.ddimg.cn/upload_img/00834/h5/btn_coupon2_small-1681297320.png');
            background-size: 100% 100%;
          }
          &.type3{
            color: #FFFFFF;
            background-image: url('https://img60.ddimg.cn/upload_img/00834/h5/btn_coupon3_small-1681297380.png');
            background-size: 100% 100%;
          }
        }
      }
    }
    .coupons::before{
      content: '券';
      width: .83rem;
      height: .83rem;
      display: block;
      opacity: 0.08;
      font-size: .64rem;
      font-weight: 600;
      border-style: solid;
      border-width: .04rem;
      border-color: var(--beforBorderColor);
      border-radius: 50%;
      text-align: center;
      line-height: .83rem;
      transform: rotate(-15deg);
      position: absolute;
      left: -.26rem;
      top: -.17rem;
    }
  }
  .coupon-mr{
    overflow: scroll;
    &::-webkit-scrollbar{width:0px;height:0px;}
    &.no-left-right-padding {
      .one,.two,.more {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
